export default {
  header: 'Preset-Sammlung',
};
